const image = ".jpg, .png, .jpeg";
const document = ".pdf, .jpeg, .zip";
const xml = ".xml, .csv, .xls, .xlsx";
const accept = { image, document, xml };
export default accept;
